// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noResults[data-v-2c1716ae]{margin-top:154px}.noResults p[data-v-2c1716ae]:first-of-type{font-weight:550;font-size:14px;color:#333}.noResults p[data-v-2c1716ae]:first-of-type,.noResults p[data-v-2c1716ae]:nth-of-type(2){font-family:AlibabaPuHuiTi;line-height:8px;text-align:center;font-style:normal}.noResults p[data-v-2c1716ae]:nth-of-type(2){font-weight:400;font-size:13px;color:#777}", ""]);
// Exports
module.exports = exports;
